<template>
  <div
    class="calendar-view-header usn"
    :class="{ 'grid-cols-7': showWeekend }"
  >
    <div
      v-for="(day, index) in daysLabels"
      :key="index"
      :class="{ 'active-header-item': currentDayIndex === index }"
      class="calendar-view-header-item"
    >
      <div class="header-item-day">
        {{ day }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';
import useTranslate from '@/utilities/composables/useTranslate';
import { getDay } from 'date-fns';
const props = defineProps({
  shortFormat: {
    type: Boolean,
    required: false,
    default: false,
  },
});
const store = useStore();
const { translate } = useTranslate();

const currentDate = Date.now();

const currentDayOfWeek = getDay(currentDate);

const showWeekend = computed(() => store.getters.getShowWeekends);

const daysArray = computed(() => {
  return (props.shortFormat ? translate('daysAbbreviationLong') : translate('weekDays')).split(',');
});

const daysLabels = computed(() => {
  return showWeekend.value ? daysArray.value : daysArray.value.slice(0, 5);
});

// currentDayOfWeek is 0 based (sunday is 0, monday is 1, etc.)
const currentDayIndex = computed(() => {
  return currentDayOfWeek === 0 ? 6 : currentDayOfWeek - 1;
});
</script>

<style lang="scss">
.calendar-view-header {
  border-bottom: 1px solid;
  @apply grid grid-cols-5 border-calendar-border;

  .calendar-view-header-item {
    @apply flex items-center justify-center;

    &:not(:last-child) {
      border-right: 1px solid;
      @apply border-calendar-border;
    }

    .header-item-day {
      @apply text-sm text-text-default py-2 truncate;
    }

    &.active-header-item {
      .header-item-day {
        @apply font-medium;
      }
    }
  }
}
</style>
